
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.01 13v-.5c.03-.75.99-1.04 2.03-2.3.37-.46.65-.79.82-1.35.29-.9.06-1.67 0-1.83-.06-.23-.34-1.02-1.14-1.56-.66-.44-1.3-.46-1.58-.46-.24 0-.78 0-1.36.3-.5.26-.8.6-.95.8-.59.72-.77 1.53-.83 1.96","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.99 17h.02","stroke":"#221B38","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    